import {Children} from 'mithril';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Sortable from '../components/Sortable';
import cleanFieldConfiguration from '../cleanFieldConfiguration';
import typeMap from './typeMap';
import Uploader from '../utils/Uploader';
import {
    FieldTemplate,
    SubmissionPayload,
    SubmissionValidationErrors
} from '../models/JsonTypes';
import Field from './Field';

interface FieldListOptions {
    configs?: FieldTemplate[]
    submission?: SubmissionPayload
    uploader?: Uploader | null
    onchange?: () => void
    disabled?: boolean
    validationErrors?: SubmissionValidationErrors
    depth?: number
    expertMode?: boolean
}

export default class FieldList {
    configs: FieldTemplate[]
    submission: SubmissionPayload
    uploader: Uploader | null
    onchange: () => void
    disabled: boolean
    validationErrors: SubmissionValidationErrors
    depth: number
    expertMode: boolean

    constructor({
                    configs = [],
                    submission = {},
                    uploader = null,
                    onchange = () => {
                    },
                    disabled = false,
                    validationErrors = {},
                    depth = 0,
                    expertMode = false,
                }: FieldListOptions) {
        this.configs = configs;
        this.submission = submission;
        this.uploader = uploader;
        this.onchange = onchange;
        this.disabled = disabled;
        this.validationErrors = validationErrors;
        this.depth = depth;
        this.expertMode = expertMode;
    }

    configureView(): Children {
        return [
            m(Sortable, {
                onsort: (origin: number, destination: number) => {
                    this.configs.splice(destination, 0, this.configs.splice(origin, 1)[0]);
                    this.onchange();
                },
                disabled: this.disabled,
            }, this.configs.map((config, index) => {
                const field: Field = new typeMap[config.type]({
                    config,
                    uploader: this.uploader,
                    onchange: () => {
                        this.onchange();
                    },
                    onduplicate: () => {
                        this.configs.splice(index + 1, 0, JSON.parse(JSON.stringify(config)));
                        cleanFieldConfiguration(this.configs[index + 1], true);
                        this.onchange();
                    },
                    ondelete: () => {
                        this.configs.splice(index, 1);
                        this.onchange();
                    },
                    disabled: this.disabled,
                    validationErrors: this.validationErrors,
                    depth: this.depth,
                    expertMode: this.expertMode,
                });

                return field.configureView();
            })),
            Button.component({
                className: 'Button Button--block',
                onclick: () => {
                    this.configs.push({
                        type: 'short',
                    });
                    this.onchange();
                },
                disabled: this.disabled,
            }, app.translator.trans('kilowhat-formulaire.forum.template-editor.add-field')),
        ];
    }

    listView(display: boolean = false): Children {
        return [
            this.configs.map(config => {
                const field = new typeMap[config.type]({
                    config,
                    submission: this.submission,
                    uploader: this.uploader,
                    onchange: () => {
                        this.onchange();
                    },
                    disabled: this.disabled,
                    validationErrors: this.validationErrors,
                    depth: this.depth,
                });

                return display ? field.displayView() : field.fillView();
            }),
        ];
    }
}
